import React from 'react';

import {TopPerformersWidgetProps} from "../models/top-performers-widget.props";
import {TopPerformersWidgetController} from "../top-performers-widget.controller";
import {Compose, ComposeSettings} from "../../../core/components/composers/compose";
import {TopPerformers, TopPerformersProps} from "../../../core/components/top-performers/components/top-performers";
import {WidgetWrapper} from "../../../core/components/misc/widget-wrapper/widget-wrapper";
import {SeeAllFooterWidget} from "../../../core/components/see-all-footer/see-all-footer";
import {ACTION_TYPES} from "../../../core/consts";
import {APP} from "../../../core/app/consts";
import {ANALYTICS} from "../../../third-party-services/analytics/analytics-consts";
import {NAVIGATION_TABS} from "../../../modules/navigation-tabs-module/navigation-tabs-module.consts";

export class TopPerformersWidgetComponentProps extends TopPerformersWidgetProps {
}

export const TopPerformersWidgetComponent = ((props: TopPerformersWidgetComponentProps) => {
  const onSeeAllClick = () => {
    props.controller.action(ACTION_TYPES.lineupsClick, {
      gameId: props.controller.state.dataSource.game.id,
      status: props.controller.state.dataSource.game.statusGroup,
      source: APP.ANALYTICS.SOURCES.topPerformers,
      entityType: ANALYTICS.ENTITY_TYPES.game,
      entityId: props.controller.state.dataSource.game.id,
      sportTypeId: props.controller.state.dataSource.game.sport.id,
    });

    return true;
  }

  const seeAllProps = {
    controller: props.controller,
    buttonLabel: props.controller.state.terms.WEB_FULL_BOX_SCORE,
    isRtl: props.controller.device.isRtl,
    onClick: props.controller.state.isGameRoute ? onSeeAllClick : () => props.onSeeAllClick?.(NAVIGATION_TABS.TAB.INDEX.GAME_CENTER.lineups)
  }

  const topPerformersProps: TopPerformersProps = {
    items: props.controller.state.categories,
    isSmallView: props.controller.device.isSmallView
  }

  const cardWrapperProps = {
    className: 'top-performers-widget',
    title: props.controller.state.title,
    controller: props.controller
  }

  return (
    <WidgetWrapper {...cardWrapperProps}>
      <TopPerformers {...topPerformersProps}/>
      {
        !props.controller.state.isScheduled && <SeeAllFooterWidget {...seeAllProps} />
      }
    </WidgetWrapper>
  )
});

const settings: ComposeSettings = {
  component: TopPerformersWidgetComponent,
  propsType: TopPerformersWidgetComponentProps,
  controllerType: TopPerformersWidgetController,

  shouldTriggerOnRenderComplete: true,
  createModule: true,


  observe: true,
}

export const TopPerformersWidget = Compose(settings);
